// extracted by mini-css-extract-plugin
module.exports = {"container":"divider_container__2K7bi","line":"divider_line__3P9zO","text":"divider_text__3Nsut","container_w_text":"divider_container_w_text__1eY0U"};